import { render, staticRenderFns } from "./SoftwareDisplay.vue?vue&type=template&id=8965b55e&scoped=true&"
import script from "./SoftwareDisplay.vue?vue&type=script&lang=js&"
export * from "./SoftwareDisplay.vue?vue&type=script&lang=js&"
import style0 from "./SoftwareDisplay.vue?vue&type=style&index=0&id=8965b55e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8965b55e",
  null
  
)

export default component.exports